import React from 'react';
import {
  useMediaQuery
} from 'react-responsive';


export default (props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  return (
    <div
      style={isBigScreen ? styles.containerBigScreen : styles.container}
    >
      {props.children}
    </div>
  )
}

const styles = {
  container: {
    backgroundColor: '#C6CED8',
    border: '1px solid transparent',
    padding: 0,
    margin: 0,
    backgroundImage: `url(${require("../assets/background.png")})`,
    minHeight: `100svh`,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
  },
  containerBigScreen: {
    backgroundColor: '#C6CED8',
    border: '1px solid transparent',
    backgroundImage: `url(${require("../assets/background.png")})`,
    minHeight: `100svh`,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    padding: '0px 0px 0px 100px',
  }
}